export default __webpack_public_path__ + "static/media/loginbg.a13bccc7.png";